import { toast, ToastOptions, ToastPosition, TypeOptions } from "react-toastify";
import { NotificationType } from "./notifications.model";

export class NotificationData {
    message: string = '';
    position: ToastPosition = 'top-center';
    autoClose: ToastOptions["autoClose"] = 5000;
    hideProgressBar: boolean = true;
    closeOnClick: boolean = true;
    pauseOnHover: boolean = false;
    draggable: boolean = false;
    progress: ToastOptions["progress"] = undefined;
    type: TypeOptions = toast.TYPE.INFO;
    style: object = {}
    toastId: ToastOptions["toastId"] = 100 * Math.random() | 0;
}

export const GetNotificationData = (type: string, msg:string): NotificationData => {

    const infoStyle = { background: '#2c6ef2', color: "#FFFFFF" };
    const successStyle = { background: '#14853D', color: "#FFFFFF" };
    const warnStyle = { background: '#FFBE00', color: "#001F52" };
    const dangerStyle = { background: '#C53532', color: "#FFFFFF" };

    let data = new NotificationData();
    data.toastId = type

    switch (type) {

        case NotificationType.OVERALL_WEIGHTAGE_EXCEEDED:
            data.message = "Error! Weightage cannot exceed overall value.";
            data.autoClose = false;
            data.type = toast.TYPE.WARNING;
            data.style = warnStyle
            break;

        case NotificationType.WEIGHTAGE_UPDATE_SUCCESS:
            data.message = "Success! CI weightage values are saved";
            data.autoClose = false;
            data.type = toast.TYPE.SUCCESS;
            data.style = successStyle
            break;

        case NotificationType.BAND_VALUE_VALIDATION_ERROR:
            data.message = msg;
            data.autoClose = false;
            data.type = toast.TYPE.WARNING;
            data.style = warnStyle
            break;

        case NotificationType.BAND_UPDATE_SUCCESS:
            data.message = msg;
            data.autoClose = false;
            data.type = toast.TYPE.SUCCESS;
            data.style = successStyle
            break; 
            
        case NotificationType.HTTP_ACTION_ERROR:
            data.message = msg || "Something went wrong!";
            data.autoClose = false;
            data.type = toast.TYPE.ERROR;
            data.style = dangerStyle
            break;
    
        default:
            data.message = msg || "Something went wrong!";
            data.autoClose = false;
            data.type = toast.TYPE.ERROR;
            data.style = dangerStyle
            break;
    }


    return data
}